import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';

import { Node } from '../types/Node';
import { openAcceptPoolNodeDialog } from './AcceptPoolNodeConfirm';

export type AcceptPoolNodeButtonProps = Readonly<{
  node: Node;
  index: number;
  siteId: string;
  clusterId: string;
  refreshBaasEdgePools: () => void;
}>;

export function AcceptPoolNodeButton(props: AcceptPoolNodeButtonProps) {
  return <>
    {renderAcceptPoolNodeButton(props)}
  </>;
}


function renderAcceptPoolNodeButton(props: AcceptPoolNodeButtonProps) {
  const acceptNodeAction = ()=>{
    openAcceptPoolNodeDialog(props);
  };

  return (
    <span className={'tb-data-grid-icon tb-padded-left-small' + buttonPaddingLeftClass} data-tb-test-id={'pool-edit-cell'}>
      <ButtonWidget
        testId={'accept-pool-node'} buttonType={ButtonType.Outline}
        onClick={acceptNodeAction}
        style={{marginRight: 10, paddingRight:5,  paddingLeft:5}}
      >
        <span className={inlineBlockClass}>
          <img className={verticalAlignClass} src={imgPath('check_14px-small.svg')} alt={''} />
          <span className={textPaddingLeftClass}>
            {Messages.dataConnectSiteSettingsAcceptPoolNodeButton()}
          </span>
        </span>
      </ButtonWidget>
    </span>
  );
}

export const inlineBlockClass = style({
  display: 'inline-block',
});
export const verticalAlignClass = style({
  verticalAlign: 'middle'
});
export const textPaddingLeftClass = style({
  paddingLeft: 2
});

export const buttonPaddingLeftClass = style({
  paddingLeft: 10
});

